<template>
  <transition name="fade">
    <div
      v-if="notification"
      class="notification-bar alert text-white border-0"
      :class="notificationTypeClass"
      role="alert"
    >
      <button
        type="button"
        class="close"
        aria-label="Close"
        v-show="notification?.is_dismissible"
        @click="destroyNotification"
      >
        <span aria-hidden="true">× </span>
      </button>
      <div v-html="notification?.message" />
    </div>
  </transition>
</template>

<script setup>
import { computed } from 'vue'

import { useNotificationStore } from '@/stores/helpers/notification.js'
import { eventEmitter } from '@/event-bus.js'


import { NOTIFICATION_SEVERITY_TYPE_CLASSES } from '@/constants/constants.js'

const props = defineProps({
  notification: {
    type: Object,
    required: true
  },
  wrapperClass: {
    type: String,
    required: false,
    default: 'mb-4'
  }
})

const notificationStore = useNotificationStore()

const notificationTypeClass = computed(() => {
  const typeClassName = NOTIFICATION_SEVERITY_TYPE_CLASSES[props.notification.type]
  let className = `alert-${typeClassName} bg-${typeClassName}`
  if (props.notification.is_dismissible) {
    className += ' alert-dismissible'
  }
  className += ` ${props.wrapperClass}`
  return className
})

const destroyNotification = () => {
  notificationStore.remove(props.notification)
  eventEmitter.emit('notificationRead', props.notification)
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
